export default {
  title: 'الوكالة',
  createAgency: 'إنشاء وكالة جديدة',
  joinAgency: 'انضم إلى وكالة',
  searchAgencyID: 'بحث عن معرف الوكالة',
  searchUserID: 'البحث عن المستخدم',
  star: 'نجم الوكالة',
  viewMember: 'عرض {{count}} العضو',
  reviewMessage: 'أثناء تقييم الوكالة، تحقق من التقدم',
  assessmentDate: 'تاريخ انتهاء التقييم',
  viewPersonal: 'عرض شخصي',
  viewIncome: 'عرض الدخل',
  dissolution: 'إشعار بحل الوكالة',
  agencyName: 'اسم الوكالة',
  agencySlogan: 'شعار الوكالة',
  agencyBackground: 'خلفية الوكالة',
  wonderfulMoment: 'لحظة رائعة',
  dissolve: 'حل الوكالة',
  dissolveAgencyContent: 'لن تحصل على راتبك من الوكالة.',
  leaveAgency: 'مغادرة الوكالة',
  disableAgency: 'حل الوكالة',
  leaveAgencyContent: 'ستغادر هذه الوكالة',
  owner: 'مالك',
  manager: 'مشرف',
  host: 'مضيف',
  setManager: 'تعيين المشرف',
  unsetManager: 'إلغاء تعيين المشرف',
  kickOut: 'طرد',
  rewardGem: 'راتب رئيس الوكالة',
  salary: {
    IncomeTips: 'دخل جوهرة وكالتي',
    hostTips: 'المضيف الذي يحصل على دخل جوهرة',
    rateTips: 'معدل مكافأة وكالتي',
  },
  supporters: 'الداعمون: {{num}}',
  keepLevelSuccessfully: 'الحفاظ على المستوى بنجاح',
  keepLevel: 'الحفاظ على مستوى',
  keepLevelRequire: 'الحفاظ على المستوى المطلوب : {{num}}',
  upgradeLevelRequires: 'ترقية المستوى يتطلب : <span>{{num}}</span>',
  kickOutContent: 'هل أنت متأكد من طرد المضيف',
  viewAgencySalary: 'عرض راتب الوكيل',
  join: 'انضم إلى وكالة',
  newMembersJoin: 'انضمام أعضاء جدد',
  assessing: 'التقييم',
  shippingAgent: 'وكيل شحن العملات',
  create: {
    title: 'إنشاء وكالة',
    newDescription: 'وصف فترة تقييم الوكالة الجديدة',
    toAgencies:
      'لمنع الوكلاء ذوي الخبرة غير الكافية والجودة الرديئة، قمنا بوضع متطلبات تقييم للوكالات المنضمة حديثًا.',
    assessmentRequirements: 'متطلبات التقييم (إقامة حفل افتتاح)',
    assessmentRequirements2: 'متطلبات حفل الافتتاح',
    diamondsRequired: 'مطلوب ألماس',
    numberOfHosts: 'متطالبات عدد المضيف',
    coinRewards: 'مكافآت العملة الذهبية',
    value: 'القيمة ($)',
    withInDays: 'في غضون {{num}} يومًا',
    assessmentTime: 'وقت التقييم:',
    assessTips: 'أكمل المهام التالية للنجاح',
    numHosts: '{{num}} س المضيفون: ',
    recruitAgency: 'تجنيد مضيفين للانضمام إلى الوكالة( بما في ذلك الوكلاء)',
    receivedGems: 'الجواهر التي حصلت عليها الوكالة بأكملها',
    agentRewards: 'مكافآت الوكيل',
    additionalNotes: 'ملاحظات',
    ifFail:
      'الملاحظات الإضافيةإذا لم تقم بإقامة حفل افتتاح وتستوفي متطلباته خلال <span>{{num}} يومًا</span> بعد إنشاء الوكالة، فسيتم إغلاق وكالتك أوتوماتيكيا. <br /> <br />    سيتم إرسال مكافآت العملات الذهبية إلى حساب الوكيل.',
    agentProfit: 'ربح الوكيل',
    basicProfit: 'الربح الأساسي',
    agentCommission: 'عمولة الوكيل تصل إلى 20%',
    activityProfit: 'ربح النشاط (الوكيل فقط)',
    activityProfit0: 'تصل مكافأة حفل افتتاح الوكيل الجديد إلى $125 على الأكثر',
    activityProfit1: 'تصل مكافأة مسابقة الغرف الأسبوعية إلى $150 على الأكثر',
    activityProfit2: 'تصل مكافأة مكافأة الغرف الأسبوعية إلى 18% على الأكثر',
    activityProfit3: 'تصل مكافأة تصنيف الوكيل الشهرية إلى 20% على الأكثر',
    activityProfit4: 'دعم الهدايا الرسمية للمناسبات ومكافآت الفعاليات الرسمية',
    ifNeed: 'إذا كنت بحاجة إلى تفاصيل السياسة، يرجى الاتصال بالموظفين الرسميين',
    customerServiceRoom: 'غرفة خدمة العملاء 1001',
  },
  submit: {
    agencyName: 'اسم الوكالة',
    agencySlogan: 'شعار الوكالة',
    introducer: 'المدعو',
    createAgency: 'إنشاء وكالة',
  },
  review: {
    recruitHosts:
      '<strong>{{count}} س المضيفون: </strong> تجنيد مضيفين للانضمام إلى الوكالة( مع وكيل)',
    receivedGems: '<strong>{{count}}</strong> :الجواهر التي حصلت عليها الوكالة بأكملها',
  },
  quit: {
    title: 'مغادرة الوكالة؟',
    joinTime: 'وقت الانضمام: ',
    quitFee: 'رسوم المغادرة:',
    quitDescription1: 'هل أنت متأكد من مغادرة هذه الوكالة؟',
    quitDescription2: 'يمكنك المغادرة مجانًا خلال 7 أيام؛',
    quitDescription3: 'بعد 7 أيام، يجب عليك الدفع.',
    confirm: 'تأكيد',
    cancel: 'إلغاء',
  },
};
